import { useNavigation } from "@react-navigation/native";
import Container from "components/general/Container";
import PageHeader from "components/general/Headers/PageHeader";
import ScrollContainer from "components/general/ScrollContainer";
import Section from "components/general/Section";
import Seo from "components/general/Seo";
import { Box, Button, Link, Typography } from "components/ui";
import { Mail } from "lucide-react-native";
import React from "react";
import { StyleSheet } from "react-native";
import { useUserPermission } from "utils/hooks/useUserPermission";
import { useIsMobile } from "utils/hooks/useIsMobile";

export const ReportTitles: Record<number, string> = {
	1: "Operations Report",
	2: "Purchases Report",
	3: "Stock Usage By Site",
	4: "Stock Usage By Site & Month",
	5: "Rechargeables Report",
	6: "Backorders Report",
	7: "Difot Report",
};

export default function Page() {
	const navigation = useNavigation<any>();
	const isMobile = useIsMobile();
	const { canApplyRechargeable } = useUserPermission();
	const optionList = Object.entries(ReportTitles).map(([id, title]) => ({
		id: Number(id),
		title,
		icon: <Mail color={"#808080"} />,
	}));

	const handleSelectReport = (reportId: number) => {
		navigation.navigate("reports/" + reportId);
	};

	// Define styles using StyleSheet
	const styles = StyleSheet.create({
		itemContainer: {
			width: isMobile ? "100%" : "23%",
			marginBottom: isMobile ? 6 : 16,
		},
	});

	return (
		<ScrollContainer>
			<Seo title="Reports | Abconet" description="Generate and analyze business and operational reports to gain insights and make informed decisions." />
			<Container>
				<PageHeader
					title={"Reports"}
					description="At Abco Products, we offer a comprehensive range of high-quality cleaning solutions, consumables, and environmental products designed to meet the needs of businesses across various industries. Our products are carefully selected to enhance efficiency, improve hygiene standards, and support sustainable cleaning practices. Whether you need premium cleaning chemicals, durable consumables, or eco-friendly alternatives, we provide reliable solutions that help you maintain a spotless and safe environment. Explore our full range and discover how Abco can support your business with innovative and effective cleaning products."
				/>
				<Section>
					<Box mb={24}>
						<Typography.H3 sx={{ marginBottom: 6 }}>Generate a report</Typography.H3>
						<Typography>Select type to generate a report</Typography>
					</Box>

					<Box paddingVertical={24} flexDirection="row" flexWrap="wrap" gap={24}>
						{optionList.map((option) => {
							if (!canApplyRechargeable && option.id === 5) {
								return null;
							}

							return (
								<Box borderRadius={12} key={option.id} style={styles.itemContainer}>
									<Button backgroundColor="$basicwhite" variant="outline" borderColor="$neutral500" gap={12} isLink width="$full" href={"/reports/" + option.id}>
										{/* <Box flexDirection="row" gap={12} bg="$basicwhite" justifyContent="flex-start" borderRadius={8} padding={12} borderWidth={1} borderColor="$neutral500"> */}
										<Box>{option.icon}</Box>
										<Box flex={1}>
											<Typography>{option.title}</Typography>
										</Box>
										{/* </Box> */}
									</Button>
								</Box>
							);
						})}
					</Box>
				</Section>
			</Container>
		</ScrollContainer>
	);
}
